import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-service-template',
  templateUrl: './dialog-delete-service-template.component.html',
  styleUrls: ['./dialog-delete-service-template.component.scss']
})
export class DialogDeleteServiceTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
